import { css } from '@emotion/css';
import { useTranslate } from '@tolgee/react';
import { useCreation, useMount } from 'ahooks';
import { Select, SelectProps } from 'antd';
import { memo } from 'react';
import { useAccountV2 } from 'views/Assistant/hooks/useAccount';

export interface RoleSelectProps<T> extends Omit<SelectProps<T>, 'options' | 'children'> {
  filter?: (account: StoreHomeV2.Account) => boolean;
}

export const useAccountSelect = <T extends any>(props: RoleSelectProps<T>) => {
  const { filter, ...otherProps } = props;
  const { t } = useTranslate();
  const { fetchList, list } = useAccountV2();

  useMount(() => {
    fetchList({ page: 1, pageSize: 99999 });
  });

  const options = useCreation(() => {
    if (!list || list.length < 1) {
      return [];
    }
    const showList = filter ? list.filter(filter) : list;
    return showList.map((account) => {
      let label = '';
      if (account.name && account.account) {
        label = `${account.account} (${account.name})`;
      } else {
        label = account.name || account.account || '';
      }
      return { label: label, value: account.id };
    });
  }, [list, filter]);

  const select = (
    <Select
      className={css`
        min-width: 344px;
        padding: 10px 0;
      `}
      placeholder={t('department.选择x', { x: t('department.帐号') })}
      options={options}
      {...otherProps}
    />
  );

  return {
    list,
    select,
  };
};

const AccountSelect = <T extends any>(props: RoleSelectProps<T>) => {
  const { select } = useAccountSelect(props);

  return select;
};

export default memo(AccountSelect);
